/* Read this regarding naming and approach: bhttps://medium.com/eightshapes-llc/space-in-design-systems-188bcbae0d62 */
import React from 'react';

const stack = (size) => () =>
    <div style={{ marginBottom: size }}/>;

const StackL = stack(20);

export default StackL;
